import { useNavigate } from "react-router-dom";
import { paths } from "../../../config/paths";
import { UniversalProfilerPage } from "../../../features/profiler/components/UniversalProfilerPage";
import { useTranslation } from "../../../lib/i18n";

export const BeautyProfilerProfiler = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

  const handleBack = () => {
    navigate(paths.app.path);
  };

  return (
    <UniversalProfilerPage
      profiler="beauty-profiler"
      subtitle={t('profiler.beautySubtitle')}
      onBack={handleBack}
    />
  );
};
